<template>
  <div class="lampGroup-content" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" label-width="auto" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item label="分组名称">
              <el-input v-model="pageInfo.group_name" placeholder="请输入分组名称" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="策略">
              <el-select
                placeholder="选择策略"
                v-model="pageInfo.ms"
                style="width: 100%"
                clearable
              >
                <el-option
                  v-for="t in strategyType"
                  :key="t.id"
                  :label="t.name"
                  :value="t.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="路灯名称">
              <el-input v-model="pageInfo.lamp_name" placeholder="请输入路灯名称" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="路灯识别号">
              <el-input v-model="pageInfo.lamp_number" placeholder="请输入路灯识别号" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="2" :offset="2" class="search-btn-box">
            <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>搜索</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>新建分组</el-button
          >
        </div>
        <div class="group-right">
          <el-button
            type="primary"
            size="small"
            @click="lightContorls(0)"
            >一键关灯</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="lightContorls(50)"
            >一键开灯</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        ref="table"
        :row-key="getRowKey"
        @selection-change="handleSelectionChange"
        @current-change="currentChange"
        >
        <el-table-column
          type="selection"
          :reserve-selection="true"
          width="80">
        </el-table-column>
        <el-table-column prop="name" label="分组名称"></el-table-column>
        <el-table-column prop="desc" label="分组说明"></el-table-column>
        <el-table-column
          label="分组策略"
          align="center"
        >
          <template slot-scope="scope">
            <template v-if="scope.row.ms">
              <span>手动策略</span>
            </template>
            <template v-else>
              <span v-if="scope.row.stg_id">{{ scope.row.stg_name }}</span>
              <span v-else>暂无策略</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          label="目前状态"
          prop="lights_status"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <i :class="lightStatusColor[scope.row.lights_status]"></i>
            <span>{{ lightStatus[scope.row.lights_status] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="is_double" label="模式">
          <template slot-scope="scope">
            <span>{{ is_doubleArr[scope.row.is_double] }}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="绑定路灯数量" width="150">
          <template slot-scope="scope">
            <span @click="openDeviceData(scope.row)" class="my-icon-button">{{scope.row.lamp_count}}个</span>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="操作">
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.ms&&scope.row.stg_id" @click="recoveryWin(scope.row)" class="blue pointer mar-r10">恢复策略</span> -->
            <span v-if="scope.row.ms" @click="recoveryWin(scope.row)" class="blue pointer mar-r10">恢复策略</span>
            <span @click="openEditWin(scope.row)" class="blue pointer mar-r15">编辑</span>
            <span @click="delItem(scope.row.id)" class="blue pointer">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="normal_dialog dialog650"
      :title="editType === 'create' ? '新建分组' : '分组修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        :rules="editOneRule"
      >
        <div v-show="editOne.step==1" class="form-info">
          <el-form-item label="分组名称" prop="name">
            <el-input v-model="editOne.name" placeholder="请输入分组名称"></el-input>
          </el-form-item>

          <el-form-item label="分组说明" class="textarea-item">
            <el-input
              v-model="editOne.desc"
              :autosize="{ minRows: 3, maxRows: 5}"
              type="textarea"
              placeholder="请输入分组说明">
            </el-input>
          </el-form-item>
          <el-form-item label="分组模式" prop="is_double">
            <el-select
              placeholder="请选择分组模式"
              v-model="editOne.is_double"
              style="width: 100%"
              @change="getStrategyList('clear');getLampList('')"
            >
              <el-option
                v-for="t in grounpType"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分组策略">
            <el-select
              placeholder="请选择分组策略"
              v-model="editOne.stg_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in strategyList"
                :key="t.id"
                :label="t.title"
                :value="t.id"
              ></el-option>
              <el-option :key="0" label="暂无策略" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="checkbox-item isdie" style="height:auto">
            <el-checkbox v-model="editOne.is_area_strategy" :disabled="areaStrategyList.length
                  ?false:true">是否叠加区域策略</el-checkbox>
          </div>
        </div>
        <div v-show="editOne.step==2" class="form-info form-info2">
          <div class="lamp-transfer">
            <el-transfer
              filterable
              filter-placeholder="请输入路灯别名或序列号"  
              :data="allDevices"
              :titles="['可选路灯', '已选路灯']"
              :button-texts="['删除到可选', '添加到已选']"
              v-model="allocated"    
            >
            </el-transfer>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <template v-if="editOne.step==1">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" size="medium" @click="groupNext(2)">下一步</el-button>
        </template>
        <div v-if="editOne.step==2" class="foot-space"> 
          <div class="footer-tip" @click="backLightList">
            <div class="icon"><svg-icon name="question"/></div>
            没有找到路灯？手动添加 >>
          </div>
  
          <div class="box-footer">
            <el-button class="cancel-btn" size="medium" @click="editOne.step=1">上一步</el-button>
            <el-button v-if="editType === 'create'" type="primary" size="medium" @click="createItem">确定</el-button>
            <el-button v-if="editType === 'update'" type="primary" size="medium" @click="updateItem">确定</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--管理路灯-->
    <el-dialog
      class="normal_dialog"
      :title="'['+deviceData.name+']管理路灯'"
      :visible.sync="deviceData.dialogVisible"
      v-if="deviceData.dialogVisible"
    >
      <device-list
        :groupId="deviceData.id"
        ref="deviceData"
        @closeMethod="closeDeviceData"
      ></device-list>
    </el-dialog>

    <el-dialog
      class="dialog600" 
      :title="'设置分组下所有路灯的亮度['+setBox.name+']'"
      :visible.sync="setBox.dialogVisible"
      v-if="setBox.dialogVisible">
      <div class="box_body">
        <el-slider
          v-model="setBox.light"
          :min="1"
          :max="100"
          show-input
        ></el-slider>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="setBox.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="(setBox.dialogVisible = false), zuContorl()"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 恢复策略 -->
    <el-dialog v-if="recoveryVisible" class="dialog750" title="恢复策略" :visible.sync="recoveryVisible">
      <div v-if="recoveryData.stg_id" class="recovery-Stategy-box">
        <div class="item">您的分组目前是{{ msType[recoveryData.ms] }}{{ lightStatus[recoveryData.lights_status] }}，您是否恢复如下定时开关灯策略?</div>
        <div class="item item2">
          <div class="name-select">
            <el-select
              placeholder="请选择路灯策略"
              v-model="recoveryData.new_stg_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in recoveryStrategyList"
                :key="t.id"
                :label="t.title"
                :value="t.id"
              ></el-option>
              <el-option :key="0" label="暂无策略" :value="0"></el-option>
            </el-select>
          </div>
          <div class="stategy_tip"> &lt;&lt; 请选择您要恢复的策略！</div>
        </div>
      </div>

      <div v-else class="recovery-Stategy-box">
        <div class="item">您的分组目前是手动模式{{ lightStatus[recoveryData.lights_status] }}，该分组未配置策略。</div>
        <div class="item">
          <div class="item item2">
            <div class="name-select">
              <el-select
                placeholder="请选择路灯策略"
                v-model="recoveryData.new_stg_id"
                style="width: 100%"
              >
                <el-option
                  v-for="t in recoveryStrategyList"
                  :key="t.id"
                  :label="t.title"
                  :value="t.id"
                ></el-option>
                <el-option :key="0" label="暂无策略" :value="0"></el-option>
              </el-select>
            </div>
            <div class="stategy_tip"> &lt;&lt; 请选择您要恢复的策略！</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer recovery-footer">
        <div class="footer-tip" @click="recoveryVisible=false; openDeviceData(recoveryData)">
          <div class="icon"><svg-icon name="question"/></div>
          <span class="blue">查看该分组绑定了哪些路灯 >></span>
        </div>
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="recoveryVisible=false">取消</el-button>
          <el-button type="primary" size="medium" @click="setRecoveryStrategy(recoveryData.id)">确定</el-button>
        </div>
      </div>
    </el-dialog>


    <!-- 一键开关灯ws -->
    <div
      v-if="lightContorl.visible"
      class="box_control_bg ws-control"
      :class="lightContorl.open?'pack-up':''"
    ></div>
    <div v-if="lightContorl.visible" class="right-control-btn" :class="lightContorl.open?'pack-up':''" @click="lightContorl.open=false">
      <div class="icon"><svg-icon :name="lightContorl.light?'lamp-close':'lamp-open'"/></div>
      <span v-if="lightContorl.cmdState==1" class="blue">执行中...</span>
      <span v-else-if="lightContorl.cmdState==2" class="blue">部分完成</span>
      <span v-else-if="lightContorl.cmdState==3" class="green">已完成</span>
      <span v-else-if="lightContorl.cmdState==4" class="red">执行失败</span>
    </div>
    <div v-if="lightContorl.visible" class="box_control lamp-control" :class="lightContorl.open?'pack-up':''">
      
      <div class="box_body">
        <div class="box_con">
          <div class="box_title">手动策略　|　一键{{ lightContorl.light?'开灯':'关灯' }}</div>

          <div v-if="lightContorl.cmdState==1" class="right-close" @click="lightContorl.open=true"><svg-icon name="retract"/></div>
          <div v-else class="right-close" @click="lightContorlClose"><i class="el-icon-close"></i></div>

          <!-- cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
          <div v-if="lightContorl.cmdState==0" class="lamp-control-tip">{{lightContorl.title}} (亮度{{lightContorl.light}}%) ?</div>
          <div v-else-if="lightContorl.cmdState==1" class="lamp-control-tip">平台命令下发成功，等待设备执行命令...</div>
          <div v-else-if="lightContorl.cmdState==2" class="lamp-control-tip">平台命令下发成功，部分设备执行命令完成。</div>
          <div v-else-if="lightContorl.cmdState==3" class="lamp-control-tip">平台命令下发成功，所有设备执行命令完成。</div>
          <div v-else-if="lightContorl.cmdState==4" class="lamp-control-tip">平台命令下发成功，设备执行失败。</div>
          
          <div class="lamp-control-list">
            <div class="item-one" v-for="(item,index) in multipleSelection" :key="index">
              <div class="item-one-pad">
                <div class="item-icon"><svg-icon :name="lightContorl.light?'lamp-close':'lamp-open'"/></div>
                <div class="item-title">{{item.name}}-{{lightContorl.cmdState}}-{{item.flag}}</div>
                <div v-if="lightContorl.cmdState" class="item-cmd">
                  <span v-if="item.flag==1" class="green">执行成功</span>
                  <span v-else-if="item.flag==0" class="red">执行失败</span>
                  <span v-else class="blue">执行中...</span>
                </div>
              </div>
            </div>
          </div>

          <!-- double_exist: 1, // 1都是单灯, 2都是双灯, 3存在单、双灯 -->
          <template v-if="lightContorl.light&&lightContorl.cmdState==0">
            <div class="lamp-control-silder">
              <div class="silder-title">{{ lightContorl.double_exist?'亮度调节一':'亮度调节' }}</div>
              <div class="silder-box">
                <el-slider
                  :disabled="lightContorl.cmdState?true:false"
                  v-model="lightContorl.light"
                  :min="1"
                  :max="100"
                  @change="manualChange = true"
                  class="lamp-silder"
                ></el-slider>
                <div class="silder-value">{{lightContorl.light}}%</div>
              </div>
            </div>

            <div v-if="lightContorl.double_exist" class="lamp-control-silder">
              <div class="silder-title">亮度调节二</div>
              <div class="silder-box">
                <el-slider
                  :disabled="lightContorl.cmdState?true:false"
                  v-model="lightContorl.light2"
                  :min="1"
                  :max="100"
                  class="lamp-silder"
                ></el-slider>
                <div class="silder-value">{{lightContorl.light2}}%</div>
              </div>
            </div>
          </template>







          <div v-if="lightContorl.cmdState==1" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>提醒：</div>
            该过程最多需要两分钟，可以点击右上角收起状态栏
          </div>

          <div v-else-if="lightContorl.cmdState==2" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            设备已{{ lightContorl.light?'开灯':'关灯' }}成功 <span class="green">{{controlResultCount(1)}}</span>个，{{ lightContorl.light?'开灯':'关灯' }}失败<span class="red">{{controlResultCount(0)}}</span>个。是否对{{ lightContorl.light?'开灯':'关灯' }}失败的设备继续下发？
          </div>

          <div v-else-if="lightContorl.cmdState==3" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            设备已{{ lightContorl.light?'开灯':'关灯' }}成功 <span class="green">{{multipleSelection.length}}</span>个，{{ lightContorl.light?'开灯':'关灯' }}失败0个。执行成功的设备若要执行<span class="blue">自动策略</span>,请在分组列表中选择<span class="blue">恢复策略</span>
          </div>
          <div v-else-if="lightContorl.cmdState==4" class="box-tips">
            <div class="tips-icon"><i class="el-icon-warning"></i>执行结果：</div>
            服务拥塞、或者网络问题命令下发及执行失败，建议您稍后重新下发！
          </div>

        </div>

        <!-- cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
        <div v-if="lightContorl.cmdState==0" class="box-footer">
          <el-button @click="lightContorlClose" class="cancel-btn" size="medium">关 闭</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">立即执行</el-button>
        </div>

        <div v-if="lightContorl.cmdState==2" class="box-footer">
          <el-button type="primary" @click="lightContorlClose" size="medium">完成</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">二次下发</el-button>
        </div>


        <div v-if="lightContorl.cmdState==3" class="box-footer">
          <el-button type="primary" @click="lightContorlClose" size="medium">执行完成</el-button>
        </div>

        <!-- 服务拥塞、或者网络问题命令下发及执行失败 -->
        <div v-if="lightContorl.cmdState==4" class="box-footer">
          <el-button @click="lightContorlClose" class="cancel-btn" size="medium">关 闭</el-button>
          <el-button type="primary" @click="lightContorlSend()" size="medium">重新下发</el-button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import lightGroupApi from "@/api/light/lampGroup";
import strategyApi from "@/api/light/strategy";
import deviceList from "@/components/light/lampGroup/deviceList.vue";
import { getToken } from '@/utils/auth';
export default {
  components: {
    deviceList
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        group_name: '', // 分组名称
        lamp_name: '', // 路灯编号
        lamp_number: '', // 路灯编号
        ms: 0 // 0自动 1手动
      },
      msType: ["自动", "手动"],
      is_doubleArr: ['单灯', '双灯'], 
      lightStatusColor: ["valuegrey", "valueyellow"],
      lightStatus: ["关灯中", "开灯中", "/"],
      grounpType:[
        {
          id: 0,
          name: '单灯模式',
        },
        {
          id: 1,
          name: '双灯模式',
        }
      ],
      strategyType: [
        {
          id: 0,
          name: '自动策略',
        },
        {
          id: 1,
          name: '手动策略',
        }
      ],
      cnt_all: 0,
      strategyList: [],
      areaStrategyList: [],
      groupSelect: [],
      editOneRule: {
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        is_double: [{ type: 'number', required: true, message: "请选择分组模式", trigger: "blur" }]
      },
      editType: -1,
      editOne: {
        id: '',
        step: 1,
        name: '',
        desc: '',
        is_double: 0,
        stg_id: 0,
        is_area_strategy: false,
        area_stg: '',
        ids: ''
      },
      sendVisible: false,
      sendData: {
        group: null,
        group_name: ''
      },
      deviceData:{
        id: null,
        name: '',
        dialogVisible: false
      },
      setBox: {
        id: null,
        name: '',
        light: 0,
        dialogVisible: false
      },
      groupSelectionInfo: {
        id: '',
        step: 1,
        name: '',
        desc: '',
        is_double: 0,
        stg_id: '',
        is_area_strategy: 0,
        area_stg: '',
        ids: ''
      },
      multipleSelection: [
        {
          address: "",
          flag: null,
          lamp_id: null,
          lights_status: null,
          name: "",
          number: "",
          ste: null,
        }
      ],
      lightContorl: {
        visible: false,
        open: false,
        title: '',
        light: 50,
        light2: 50,
        double_exist: 0,
        result: {
          success: 0,
          file: 0,
          filesIds: ''
        },
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败 
      },
      websocketObj: null, // websocket实例对象
      websocket: {
        socketReconnectNum: 0,
        socketReconnectTimer: null, // 计时器对象——重连
        socketReconnectLock: false, // WebSocket重连的锁
        socketLeaveFlag: false, // 离开标记（解决 退出登录再登录 时出现的 多次相同推送 问题，出现的本质是多次建立了WebSocket连接）
        timeout: 5 * 1000,
        timeoutObj: null,
        serverTimeoutObj: null
      },
      allDevices: [],
      allocated: [],
      recoveryVisible: false,
      recoveryData: {
        id: null,
        stg_id: 0,
        new_stg_id: 0,
        stg_name: '',
        lights_status: 0,
        ms: 0
      }
    };
  },
  destroyed() {
    this.wsclose();
    if(this.websocketObj){
      this.wsclose();
    }
  },
  async mounted() {
    await this.getTableData(this.pageInfo.page);
    await this.getStrategyList('',3) // 获取策略列表
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightGroupApi.lightGroupList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },

    getStrategyList(mode='', type=1) { // 获取策略列表
      if(mode=='clear'){
        this.editOne.stg_id = 0
      }
      strategyApi.strategyList({
        strategy_type: type,
        type: 0, //区分集中控制器的策略（区域策略）
        is_double: this.editOne.is_double,
        page: 1,
        pageSize: 200
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(type==1){
            this.strategyList = resData.list;
          }else{
            this.areaStrategyList = resData.list;
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        this.editOne = {
          id: '',
          step: 1,
          name: '',
          desc: '',
          is_double: 0,
          stg_id: 0,
          is_area_strategy: false,
          area_stg: '',
          ids: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          step: 1,
          id: index.id,
          name: index.name,
          desc: index.desc,
          is_double: index.is_double,
          stg_id: index.stg_id,
          is_area_strategy: index.is_area_strategy?true:false,
          area_stg: index.area_stg,
          ids: ''
        };
        this.editType = "update";
      }
      this.getLampList('')
      this.getStrategyList()
      this.dialogVisible = true
    },
    updateItem() {
      if(!this.editOne.name){
        return this.$message.error('请填写分组名称！');
      }
      this.editOne.ids='';
      if(this.allocated.length){
        this.editOne.ids=this.allocated.toString();
      }
      this.editOne.is_area_strategy?this.editOne.is_area_strategy=1:this.editOne.is_area_strategy=0
      lightGroupApi.lightGroupEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    createItem() {
      if(!this.editOne.name){
        return this.$message.error('请填写分组名称！');
      }
      this.editOne.ids='';
      if(this.allocated.length){
        this.editOne.ids=this.allocated.toString();
      }
      this.editOne.is_area_strategy?this.editOne.is_area_strategy=1:this.editOne.is_area_strategy=0
      lightGroupApi.lightGroupAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightGroupApi.lightGroupDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$popupMessage({
                type: 'success',
                title: "删除成功",
                // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
              })
              this.getTableData(this.pageInfo.page);
            } else {
              this.$popupMessage({
                type: 'error',
                title: "提示",
                msg: res.data.message,
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    groupNext(step){
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          this.editOne.step=step
        } else {
          return false
        }
      })
    },

    recoveryWin(row){
      // 获取策略列表
      strategyApi.strategyList({
        is_double: row.is_double,
        strategy_type: 1,
        page: 1,
        pageSize: 200
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.recoveryStrategyList = resData.list;
          this.recoveryData = {
            id: row.id,
            stg_id: row.stg_id,
            new_stg_id: row.stg_id,
            stg_name: row.stg_name,
            lights_status: row.lights_status,
            ms: row.ms
          }
          this.recoveryVisible = true
        }
      })
    },
    setRecoveryStrategy(id){  //还原策略
      strategyApi.recoveryStrategy({
        id: id,
        stg_id: this.recoveryData.new_stg_id,
        type: 2
      }).then((res) => {
        if (res.data.code === 1000) {
          this.recoveryVisible =false
          this.$popupMessage({
            type: 'success',
            title: "恢复成功"
            // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
          })
          this.getTableData(this.pageInfo.page);
        } else {
          this.$popupMessage({
            type: 'error',
            title: "提示",
            msg: res.data.message,
          })
        }
      })
    },
    
    openDeviceData(value) {
      let newParams = { 
        id: value.id,
        name: value.name,
        dialogVisible: true
      }
      this.deviceData = newParams
    },
    closeDeviceData() {
      this.deviceData = {
        id: null,
        name: '',
        dialogVisible: false
      }
    },
    
    zuContorl () {
      let sendData = {
        light: this.setBox.light
      }
      lightGroupApi.groupControl(this.setBox.id,sendData).then(res => {
        if (res.data.code === 1000) {
          this.$message.success('下发成功')
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 10
      this.getTableData(1)
    },
    selectChange(value) {
      if (value) {
        this.getTableData(this.pageInfo.page);
      } else {
        return value;
      }
    },
    getRowKey (row) {
      return row.id
    },
    getLampList(id) {
      let that = this
      lightGroupApi.getLampList({
        strategy_mode: 1,
        is_double: that.editOne.is_double,
        id: id,
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const lamp of resData) {
              arrData.push({
                key: lamp.lamp_id,
                label: lamp.name+'-'+lamp.number
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getLampList(that.editOne.id)
            }
          }
        }
      })
    },
    handleSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val[val.length - 1]);
      }
      this.groupSelectionInfo = val[val.length - 1]
      if(!this.groupSelectionInfo) {
        this.groupSelectionInfo = {
          id: '',
          step: 1,
          name: '',
          desc: '',
          is_double: 0,
          stg_id: '',
          is_area_strategy: 0,
          area_stg: '',
          ids: ''
        }
      }
    },

    currentChange(val) {
      this.$refs.table.toggleRowSelection(val);
    },

    lightContorls (light) {
      if(!this.groupSelectionInfo.id) return this.$message.error('请先勾选分组！');
      lightGroupApi.getGroupLamps({
        page: 1,
        pageSize: 10000,
        lamp_group: this.groupSelectionInfo.id // 灯组Id
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data.list;
          if(resData.length<1){
            this.$popupMessage({
              type: 'error',
              title: "分组下无路灯",
              msg: '请给该分组添加路灯或更换分组！'
            })
            return
          }
          resData = resData.map(item => ({ ...item, flag: null }));
          
          this.multipleSelection = resData;
          
          this.lightContorl= {
            visible: true,
            open: false,
            title: `您确定让以下设备执行立即${light ? '开灯' : '关灯'}`,
            light,
            light2: light,
            double_exist: this.groupSelectionInfo.is_double,
            result: {
              success: 0,
              file: 0,
              filesIds: ''
            },
            cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败 
          }
          
        }
      });
    },
    lightContorlClose(){
      this.lightContorl = {
        visible: false,
        open: false,
        title: '',
        double_exist: 0,
        light: 50,
        light2: 50,
        result: {success: 0, file: 0, filesIds: ''},
        cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  5 socket失败
      },

      this.multipleSelection = []

      this.$refs.table.clearSelection() //清除选中的数据
      this.wsclose();
      this.getTableData(this.pageInfo.page);
    },
    wsclose(){
      if(this.websocketObj){
        this.websocketObj.close()
        this.websocketObj=null
        this.websocket.socketReconnectNum = 0
        this.websocket.socketReconnectLock = true
        this.websocket.socketLeaveFlag = true
      }
    },
    lightContorlSend(){
      if(this.multipleSelection.length<1){
        return this.$message.error('请至少选择一个路灯操作！');
      }
      this.createWebSocket();  // 建立WebSocket
    },
    
    controlResultCount(type){
      //type 0 执行失败， 1执行完成
      let arr = this.multipleSelection
      // flag: null 执行中/未开始，0 执行失败， 1执行完成
      return arr.filter(el => el.flag == type).length
    },
    // 建立webSocket
    createWebSocket(reconnect=0) { // reconnect 是否重连
      let lamp_ids= '';
      let newSelection = []
      this.multipleSelection.forEach(selection => {
        if (!reconnect || selection.flag != 1) {
            lamp_ids += selection.lamp_id + ',';
            newSelection.push(selection);
        }
      });
      
      lamp_ids = lamp_ids.slice(0, -1); // 删除最后一个逗号

      this.websocket.socketReconnectLock = false
      this.websocket.socketLeaveFlag = false

      const that = this
      const wsLink = `${process.env.VUE_APP_BASE_WSS}/message?type=2&token=${getToken()}`;
      try {
        that.websocketObj = new WebSocket(wsLink);
        // 连接成功
        that.websocketObj.onopen = function (e) {
          // console.log('WebSocket连接成功', 'Websocket Connection open ...', e);
          let lampCmd = '{"cmd":"message.control","data":{"light":'+that.lightContorl.light+', "light2":'+that.lightContorl.light2+', "control_type": 1,"group": '+that.groupSelectionInfo.id+',"lamp_ids":"'+lamp_ids+'", "reconnect":'+reconnect+'}}'
          // console.log('WebSocket发送数据','websock.send', lampCmd)
          that.websocketObj.send(lampCmd)
          that.lightContorl.cmdState = 1
          // cmdState: 0   // 0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败
          that.multipleSelection = newSelection
          if(reconnect==0){
            for(let i = 0; i < that.multipleSelection.length; i++){
              that.multipleSelection[i].flag = null
            }
          }
          that.resetHeart(1); // 心跳检测重置
        };

        // 接收到消息
        that.websocketObj.onmessage = function (e) {
          if (e.data.indexOf('heartbeat.pong') > -1) {
            // 心跳回复——心跳检测重置
            // 收到心跳检测回复就说明连接正常
            // console.log('WebSocket数据接收，收到心跳检测回复');
            // 心跳检测重置
            that.resetHeart(1);
          } else {
            const resData = JSON.parse(e.data);
            const { cmd, data } = resData;
            // console.log('普通推送——正常处理:', 'cmd', cmd, 'data', data);
            if(cmd=='message.control'){
              if(data.lamp_id){
                let index = that.getArrayIndex(that.multipleSelection, data.lamp_id)
                if(index>-1){
                  // flag: null 执行中/未开始，0 执行失败， 1执行完成
                  that.multipleSelection[index].flag = data.flag
                }
              }
            } else if(cmd=='message.complete'){
              // complete  1部分完成 2已完成 3失败
              that.lightContorl.result = {
                success: 0,
                file: 0,
                filesIds: ''
              }
              // <!-- lightContorl.cmdState:  0.未发送执行  1.已发送命令  2.部分完成  3.已完成 4.失败  -->
              if(data.complete==1){ 
                for(let i = 0; i < that.multipleSelection.length; i++){
                  // flag: null 执行中/未开始，0 执行失败， 1执行完成
                  if(that.multipleSelection[i].flag==null){
                    that.multipleSelection[i].flag = 0
                  }
                }
                that.lightContorl.cmdState = 2
              } else if(data.complete==2){
                that.lightContorl.cmdState = 3 
              } else if(data.complete==3){
                for(let i = 0; i < that.multipleSelection.length; i++){
                  that.multipleSelection[i].flag = 0
                }
                that.lightContorl.cmdState = 4
              }
              that.wsclose();
            }
          }
        };

        // 向后端发送数据的回调
        that.websocketObj.onsend = function (e) {
          // console.log('WebSocket发送信息给后端', 'Websocket onsend...', e);
        },

        // 连接失败事件
        that.websocketObj.onerror = function (e) {
          // console.log('WebSocket连接发生错误', 'Websocket error ...', e);
          that.socketReconnect();
        };

        // 链接关闭的回调方法
        that.websocketObj.onclose = function (e) {
          // console.log('WebSocket连接已关闭', 'Websocket Connection closed.', e);
          // 心跳检测重置
          that.resetHeart(0);
          if (!that.websocket.socketLeaveFlag) {
            // 没有离开——重连
            // websocket重连
            // console.log('WebSocket关闭，用户未离开——重连');
            that.socketReconnect();
          }
        };

        // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
        window.onbeforeunload = () => {
          that.wsclose();
        };
      } catch (e) {
        // console.log('WebSocket连接不上', e);
        // websocket重连
        that.socketReconnect();
      }
    },

    // websocket重连
    socketReconnect() {
      if(this.websocket.socketReconnectNum>5){
        this.$message.error('websocket连接失败，请稍后再试')
        this.wsclose();
        this.lightContorl.cmdState = 4
        return
      }
      this.websocket.socketReconnectNum++
      if (this.websocket.socketReconnectLock) {
        return;
      }
      this.websocket.socketReconnectLock = true
      this.websocket.socketReconnectTimer && clearTimeout(this.websocket.socketReconnectTimer)
      this.websocket.socketReconnectTimer = setTimeout(() => {
        // console.log('WebSocket:重连中...')
        this.websocket.socketReconnectLock = false
        // websocket启动
        this.createWebSocket(1)
      }, 1000)
    },

    // 重置心跳
    resetHeart(type=0) {
      // 清除时间
      clearTimeout(this.websocket.timeoutObj)
      clearTimeout(this.websocket.serverTimeoutObj)
      if (type) {
        // 重启心跳
        this.startHeart()
      }
    },

    // 开启心跳
    startHeart() {
      let that = this
      // console.log('准备发送心跳', that.websocketObj);
      that.websocket.timeoutObj && clearTimeout(that.websocket.timeoutObj);
      that.websocket.serverTimeoutObj && clearTimeout(that.websocket.serverTimeoutObj);
      that.websocket.timeoutObj = setTimeout(() => {
        // 这里向后端发送一个心跳检测，后端收到后，会返回一个心跳回复
        if (that.websocketObj.readyState === 1) {
          // 如果连接正常
          that.websocketObj.send('{"cmd":"heartbeat.ping","data":{}}');
          // console.log('发送心跳检测', '{"cmd":"heartbeat.ping","data":{}}');
        } else {
          // 否则重连
          that.socketReconnect();
        }
        that.websocket.serverTimeoutObj = setTimeout(() => {
          // 如果超过一定时间还没重置计时器，说明websocket与后端断开了
          // console.log('未收到心跳检测回复');
          // 关闭WebSocket
          that.websocketObj.close();
        }, that.websocket.timeout);
      }, that.websocket.timeout);
    },

    // 查找数组序号
    getArrayIndex(arr, str) {
      let i = arr.length
      while (i--) {
        if (arr[i].lamp_id == str) {
          return i
        }
      }
      return -1
    },

    backLightList(){
      this.$router.push({
        name: 'lightList',
        path:"/light/lightList",
        params:{cmd: 'insert'}
      })
    },
    goStrategy(stg_id){
      this.$router.push({
        name: 'strategys',
        path:"/light/strategys",
        params:{stgId: stg_id}
      })
    }
  }
};
</script>
<style lang='less' scoped>
.lampGroup-content {
  width: 100%;
  .form-info{
    // height:340px;
    margin-left: -10px;
    &.form-info2{
      height:460px;
    }
  }
  
  .box_control {
    width: 600px !important;
    height: auto !important;
    margin-top: -200px !important;
    margin-left: -300px !important;
    .box_body {
      padding-bottom: 25px;
    }
  }
  .box_control_bg{
    transition: all 0.5s;
    &.pack-up{
      width:0;
      height:0;
      overflow: hidden;
    }
  }

  .lamp-control{
    width: 860px !important;
    height: auto !important;
    top: 0 !important;
    margin-top: 130px !important;
    margin-left: -430px !important;
    color: #333 !important;
    transition: all 0.3s;
    opacity: 1;
    .box_body {
      padding:60px;
      transition: all 1s;
      .box_con{
        padding-bottom: 50px;
        padding: relative;
        display: block;
        box-sizing: border-box;
        width:740px;
        // height:490px;
        .box_title{
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 10px 10px 20px;
          color:#1d2129;
          font-size: 24px;
          font-weight: 600;
        }
        .right-close{
          position: absolute;
          color:#898ea1;
          right:30px;
          top:30px;
          font-size: 20px;
          cursor: pointer;
        }
        .lamp-control-tip{
          padding: 10px 0;
          font-size: 14px;
        }
        .lamp-control-list{
          margin: 0  -25px;
          height:260px;
          overflow-y: auto;
          &::before, &::after {
            content: " ";
            display: table;
          }
          &::after {
            clear: both;
          }
          .item-one{
            width:50%;
            float: left;
            box-sizing: border-box;
            padding: 8px 25px;
            .item-one-pad{
              border-radius: 3px;
              border: 1px solid #ff8b23;
              display: flex;
              align-items: center;
              position: relative;
              padding: 8px 15px;
              box-sizing: border-box;
              .item-icon{
                font-size: 25px;
                color: #ff8b23;
                margin-right: 10px;
              }
              .item-title{
                width:200px;
                font-size: 14px;
                color: #111;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
              }
              .item-close{
                font-size: 21px;
                color: #ff8b23;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }

              .item-cmd{
                font-size: 14px;
                position: absolute;
                right:15px;
                top:50%;
                transform: translate(0,-50%);
                cursor: pointer;
              }
            }
          }
        }
        .lamp-control-silder{
          padding:40px 0 10px;
          .silder-title{
            font-size:18px;
            padding-bottom:10px;
          }
          .silder-box{
            display: flex;
            width:100%;
            align-items: center;
            justify-content: space-between;
            .lamp-silder{
              flex:1;
              width:100%;
            }
            .silder-value{
              font-size:18px;
              margin-left: 20px;
            }
          }


        }

        .box-tips{
          padding: 40px 0 10px;
          font-size:14px;
          line-height: 1.8;
          .tips-icon{
            float: left;
            color:#2d8cf0;
            display: flex;
            align-items: center;
            i{
              font-size: 18px;
              margin-right: 5px;
            }
          }
        }

      }
    }
    &.pack-up{
      opacity: 0;
    }
  }
  .right-control-btn{
    position: fixed;
    right:30px;
    top:64px;
    width:120px;
    height:50px;
    z-index: 999999;
    background-color: #fff;
    box-shadow: 3px 1px 10px rgba(0,0,0,0.1);
    border-radius: 50px;
    color:#2d8cf0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.3s;
    cursor: pointer;
    opacity: 0;
    .icon{
      color:#ff881e;
      font-size: 28px;
      margin-right: 6px;
    }
    &.pack-up{
      opacity: 1;
    }
  }
  
}
</style>
<style lang="less">
.lampGroup-content{
  .el-table__header-wrapper{
    .el-checkbox{
      display: none !important;
    }
  }
  .form-info{
    .el-form-item__label{
      width:80px;
    }
  }
}
</style>